import { gql } from '@apollo/client';

export default gql`
  mutation login($email: String!, $password: String!) {
    login(input: { email: $email, password: $password }) {
      user {
        id
        email
      }
      expiresIn
      twoFactor
    }
  }
`;
